import React from 'react'
import EmojiObjectsOutlinedIcon from '@material-ui/icons/EmojiObjectsOutlined';

function Header() {
  return (
    <header>
        
        <h1> <EmojiObjectsOutlinedIcon fontSize='large'/> Keep</h1>
    </header>
  )
}

export default Header